import React from "react";
import { Link } from "react-router-dom";
import { rnds, tees } from "./helpers";

const Rounds = ({ match }) => {
  const rndOptions = rnds().map((item, index) => {
    let liClass = "subpage-tab";
    let liStyle = {};
    if (match.params && match.params.rnd === item) {
      liClass += " selected";
      liStyle.color = "#fff";
    }

    let tee = tees()[0];
    if (match.params && match.params.tee) {
      tee = match.params.tee;
    }

    return (
      <li key={index} className={liClass}>
        <Link
          to={{
            pathname: `/${item}/${tee}`
          }}
          style={liStyle}
        >{`Round ${item}`}</Link>
      </li>
    );
  });

  return <ul>{rndOptions}</ul>;
};

export default Rounds;



// WEBPACK FOOTER //
// ./src/Rounds.js